/* eslint-disable no-process-env */

export enum AppEnvironment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export interface Environment {
  NEXTAUTH_URL: string;
  JWT_SECRET: string;
  HASURA_DATABASE_URL: string;
  HASURA_GRAPHQL_ADMIN_SECRET: string;
  NEXT_PUBLIC_HASURA_GRAPHQL_ENDPOINT: string;
  GOOGLE_CLIENT_ID: string;
  GOOGLE_CLIENT_SECRET: string;
  NEXT_PUBLIC_SEGMENT_WRITE_KEY: string;
  NEXT_PUBLIC_SENTRY_DSN: string;
  NEXT_PUBLIC_ENVIRONMENT: AppEnvironment;
  NEXT_PUBLIC_HUBSPOT_KEY: string;
}

export function loadEnv(): Environment {
  const env: Environment = {
    NEXTAUTH_URL: process.env.NEXTAUTH_URL || '',
    JWT_SECRET: process.env.JWT_SECRET || '',
    HASURA_DATABASE_URL: process.env.HASURA_DATABASE_URL || '',
    HASURA_GRAPHQL_ADMIN_SECRET: process.env.HASURA_GRAPHQL_ADMIN_SECRET || '',
    NEXT_PUBLIC_HASURA_GRAPHQL_ENDPOINT: process.env.NEXT_PUBLIC_HASURA_GRAPHQL_ENDPOINT || '',
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID || '',
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET || '',
    NEXT_PUBLIC_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY || '',
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN || '',
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT as AppEnvironment,
    NEXT_PUBLIC_HUBSPOT_KEY: process.env.NEXT_PUBLIC_HUBSPOT_KEY || '',
  };
  return env;
}
